import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { auth } from "../firebase-config";
import LoginPage from "./LoginPage";

function LoginPageWrapper() {
    const [user, setUser] = useState(null);
  
    useEffect(() => {
      onAuthStateChanged(auth, (currentUser) => {
        setUser(currentUser);
      });
    }, [auth]);
  
    if (user) {
      return <Navigate to="/home/info" />;
    } else {
      return <LoginPage />;
    }
  }

  export default LoginPageWrapper;